import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import globalStyles from "../styles/globalStyles";
import { css, StyleSheet } from "aphrodite";
import Dropdown from "./Dropdown";
import React, { PureComponent } from "react";
import { Container, Row, Column } from "../grid";
import PropTypes from "prop-types";

const styles = StyleSheet.create({
	category: {
		display: "flex",
		borderRight: `1px solid ${colors.black}`,
		paddingRight: 8,
		paddingLeft: 8,

		"-webkit-touch-callout": "none" /* iOS Safari */,
		"-webkit-user-select": "none" /* Safari */,
		"-khtml-user-select": "none" /* Konqueror HTML */,
		"-moz-user-select": "none" /* Firefox */,
		"-ms-user-select": "none" /* Internet Explorer/Edge */,
		"user-select":
			"none" /* Non-prefixed version, currently
		                                supported by Chrome and Opera */,

		[breakpoints.mobileOnly]: {
			fontSize: 12,
		},
	},
	categoryEnd: {
		border: "none",
	},
	categoryName: {
		fontWeight: "bold",
		lineHeight: 1.75,
		fontSize: 12,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	categoryNameSelected: {
		textDecoration: "underline",
		color: colors.teal,
	},
	container: {
		display: "flex",
		paddingTop: 10,
		paddingBottom: 10,
		[breakpoints.mobileOnly]: {
			justifyContent: "center",
		},
	},
	divider: {
		marginLeft: 8,
		marginRight: 8,
	},
	fullPageContainer: {
		borderTop: "1px dashed black",
		borderBottom: "1px dashed black",
	},
});

export default class ClassesFilterContainer extends PureComponent {
	static propTypes = {
		selectFilter: PropTypes.func.isRequired,
		selectedFilter: PropTypes.string.isRequired,
		options: PropTypes.array.isRequired,
	};

	_selectFilter = filter => {
		if (filter !== this.props.selectedFilter) {
			this.props.selectFilter(filter);
		}
	};

	_renderAsDropDown = () => {
		return (
			<Container>
				<Row>
					<Column>
						<Dropdown
							selectedValue={this.props.selectedFilter}
							selectValue={this.props.selectFilter}
							options={this.props.options}
						/>
					</Column>
				</Row>
			</Container>
		);
	};

	_renderAsList = () => {
		return (
			<div className={css(styles.fullPageContainer)}>
				<Container>
					<Row>
						<Column>
							<div className={css(styles.container)}>
								{this.props.options.map((opt, i) => (
									<div
										className={css([
											styles.category,
											i === this.props.options.length - 1
												? styles.categoryEnd
												: "",
										])}
										key={opt.value}
									>
										<div
											className={css([
												styles.categoryName,
												this.props.selectedFilter === opt.value
													? styles.categoryNameSelected
													: "",
											])}
											onClick={() => this._selectFilter(opt.value)}
										>
											{opt.label}
										</div>
									</div>
								))}
							</div>
						</Column>
					</Row>
				</Container>
			</div>
		);
	};

	render() {
		return (
			<div>
				<div className={css(globalStyles.tabletAndUp)}>{this._renderAsList()}</div>
				<div className={css(globalStyles.mobileOnly)}>{this._renderAsDropDown()}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ClassesFilterContainer.js